import React from 'react'
import { useSelector } from 'react-redux'

// Waits for airSearchPromise to resolve in Redux, triggering the fallback
// on any React Suspense boundaries until it's does
const AirSearchPromiseResolver = ({ children }) => {
  useSelector((state) => state.airSearchPromise)?.read()
  return <>{children}</>
}

export default AirSearchPromiseResolver
